let agoraClient = null;
let localAudioTrack = null;
let localVideoTrack = null;
let remoteVideoTrack = null;
let remoteAudioTrack = null;
let firebaseRef = null
let firebaseDBRef = null
let rtm = null;


document.addEventListener('alpine:init', () => {
    Alpine.data('videoCallFeature', () => ({
        channelsList: null,
        isCsrInCall: null,
        channelName: null,
        token: null,
        appId: null,
        hasRemoteUserJoined: false,
        isAudioMuted: false,
        isVideoJoined: false,
        remoteUserId: null,
        callTimeoutRef: null,
        callStatusEnum: {
            AVAILABLE: 'AVAILABLE',
            BUSY: 'BUSY',
            OFFLINE: 'OFFLINE'
        },

        notice: {
            show: false,
            type: 'error',
            text: ''
        },
        agClient: null,

        isCameraEnabled: false,
        isRemoteUserCameraEnabled: false,
        remoteUsersListMap: new Map(),
        channelStateUpdateListener: null,
        startDuration: null,
        isChatComponentVisible: false,
        chatMessages: [],
        userId: null,
        messageHandler: null,
        isUserAdmitted: null,
        rtmToken: null,
        areLatestMessagesFetched: false,
        isDeviceMobile: false,

        headers: {
            "Content-type": "application/json; charset=UTF-8",
            "X-CSRFToken": window.csrf,
            "Accept-Language": window.lang,
        },

        videoCallJoinDelayTimeoutRef: null,

        showError(message) {
            this.notice = {
                show: true,
                type: 'error',
                text: message
            }
            setTimeout(() => {
                this.notice.show = false
            }, 5000)
        },
        showSuccess(message) {
            this.notice = {
                show: true,
                type: "success",
                text: message,
            };
            setTimeout(() => {
                this.notice.show = false;
            }, 5000);
        },
        isVsrListLoaderActive: null,
        csrProfilePicture: null,
        chatInput: null,
        isIncomingCallDialogOpen: false,
        posthogFeatureFlagData: null,
        incomingCallRingtone: null,
        incomingCallCsr: null,
        incomingCallTimeoutRef: null,
        csrAssistId: null,
        snowflake: null,
        callRingtone: null,

        remoteUsersTrackList: {},

        init() {

            console.log("Initializing video call service...", window.username);
            console.log("Initializing firebase...", posthog);
            this.showSupportWidget = false

            const params = new URLSearchParams(window.location.search);
            this.csrAssistId = params.get("csr_user_id");
            this.snowflake = params.get("quote_id");

            const url = window.location.origin + window.location.pathname;
            window.history.replaceState(null, '', url);

            if (window.username) {
                this.userId = window.username
            } else if (posthog && posthog?.__loaded) {
                this.userId = posthog?.get_distinct_id()
            } else {
                this.userId = this.generateRandomWord()
            }

            this.isDeviceMobile = this.isMobile();

            this.initFirebase();
            this.initAgoraClient();
            this.initializeRingtone()
            this.messageHandler = (event) => this.messageReceived(event);
            this.channelStateUpdateListener = (snapshot, channelName, appId) => this.firebaseCallStateEventHandler(snapshot, channelName, appId);

        },

        initializeRingtone() {
            this.incomingCallRingtone = new Audio(RINGTONE_URL);
            this.callRingtone = new Audio(CSR_WAITING_CALL_RINGTONE_URL);
            this.callRingtone.loop = true
            this.incomingCallRingtone.loop = true
        },

        executeAfterJoinDelay() {
            this.videoCallJoinDelayTimeoutRef = setTimeout(() => {
                dataLayer.push({event: 'onCustomerCallJoinDelayTimeout', 'csrId': this.channelName});
            }, 15000)
        },

        isUrl(msg) {
            const urlRegex = /^(https?:\/\/[^\s/$.?#].[^\s]*)$/i;
            return urlRegex.test(msg);
        },
        parseMessage(msg) {
            const urlRegex = /(https?:\/\/[^\s]+)/g;
            const parts = [];
            let lastIndex = 0;
            let match;

            while ((match = urlRegex.exec(msg)) !== null) {
                if (match.index > lastIndex) {
                    const text = msg.slice(lastIndex, match.index).replace(/\n/g, "<br>");
                    parts.push({text: DOMPurify.sanitize(text), isUrl: false});
                }
                parts.push({text: match[0], isUrl: true});
                lastIndex = urlRegex.lastIndex;
            }

            if (lastIndex < msg.length) {
                const text = msg.slice(lastIndex).replace(/\n/g, "<br>");
                parts.push({text, isUrl: false});
            }

            return parts;
        },

        isMobile() {
            if (navigator.userAgentData) {
                return navigator.userAgentData.mobile;
            }
            return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
        },

        onAcceptClicked() {
            dataLayer.push({event: 'onIncomingCallDialogAcceptClicked'});
            const user = Object.keys(this.channelsList).find((channel) => this.channelsList[channel].channelName === this.incomingCallCsr.channelName);
            this.isIncomingCallDialogOpen = false
            this.incomingCallRingtone.pause();
            this.incomingCallRingtone.currentTime = 0
            if (!user) {
                this.showError(BUSY_ERR_MSG);
                return;
            }
            this.joinCall(this.channelsList[user]?.channelName, this.channelsList[user]?.status, this.channelsList[user]?.channelName, this.channelsList[user]?.appId, this.channelsList[user]?.profile_image, 'Insurance Support Incoming Call Dialog');
        },

        onDenyClicked() {
            dataLayer.push({event: 'onIncomingCallDialogDenyClicked'});
            this.incomingCallRingtone.pause();
            this.incomingCallRingtone.currentTime = 0
            this.isIncomingCallDialogOpen = false
        },


        generateRandomWord() {
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let result = '';
            for (let i = 0; i < 6; i++) {
                result += characters.charAt(Math.floor(Math.random() * characters.length));
            }
            return result;
        },

        initAgoraClient() {
            agoraClient = AgoraRTC.createClient({mode: 'rtc', codec: 'vp8'});
            this.agClient = agoraClient
            this.onUserJoined(agoraClient);
            this.onUserLeft(agoraClient);
        },


        async admitUser(user, mediaType, agoClient = null) {
            if (!agoClient) {
                agoClient = this.agClient
            }


            if (this.remoteUsersTrackList[user.uid]?.video && !this.remoteUsersTrackList[user.uid].isVideoTrackSubscribed) {
                await agoClient.subscribe(user, 'video');
                this.remoteUsersTrackList[user.uid].isVideoTrackSubscribed = true
                remoteVideoTrack = user.videoTrack;
                remoteVideoTrack.play('remote-stream');  // Play remote video
                this.isRemoteUserCameraEnabled = true
            }

            if (this.remoteUsersTrackList[user.uid]?.audio && !this.remoteUsersTrackList[user.uid].isAudioTrackSubscribed) {
                await agoClient.subscribe(user, 'audio');
                this.remoteUsersTrackList[user.uid].isAudioTrackSubscribed = true
                remoteAudioTrack = user.audioTrack;
                remoteAudioTrack.play();  // Play remote audio
            }

            this.hasRemoteUserJoined = true;
            console.log(`Subscribed to user ${user.uid} with mediaType ${mediaType}`);

        },

        showMessage(user, msg, timeStamp) {
            this.chatMessages.push({
                'user': 'CSR',
                msg: msg,
                'timestamp': this.convertTimestampToDateTime(timeStamp),
                isUserLeft: false
            });
        },

        convertTimestampToDateTime(timestamp) {
            const date = new Date(timestamp);

            const formattedDate = date.toLocaleDateString();
            const formattedTime = date.toLocaleTimeString();

            return `${formattedTime}`;
        },

        onSendClicked(e, messages = null) {
            dataLayer.push({event: 'onChatMessageSendClicked', 'user': 'Customer', 'csrId': this.channelName});
            const isTextSizeExceeded = this.isMoreThan32KB(messages || this.chatInput);
            if (isTextSizeExceeded) {
                this.showError('Message is too long.Please reduce the size');
                return
            }
            const message = messages || this.chatInput
            if (!message) return
            this.chatMessages.push({
                user: YOU_BAHASA,
                msg: message,
                'timestamp': new Date().toLocaleTimeString(),
                isUserLeft: false
            })
            this.publishMessage(message, this.channelName);
            this.chatInput = '';
            this.$refs.chatInputRef.focus();
            this.scrollToBottom();
        },

        scrollToBottom() {
            this.$nextTick(() => {
                const container = this.$refs.messageContainer;
                if (container) {
                    container.scrollTop = container.scrollHeight;
                }
            });
        },


        publishMessage: async (message, channelName, customType = 'chatMessage') => {
            const publishOptions = {'customType': customType, channelType: 'MESSAGE'};
            if (customType == 'userJoinMessage') {
                message = JSON.stringify(message)
            }
            try {
                const result = await rtm.publish(channelName, message, publishOptions);
            } catch (error) {
                dataLayer.push({
                    event: 'onLiveCallChatError',
                    'error': "Published message error:" + error,
                    'csrId': this.channelName
                });
                console.error(error);
            }
        },

        messageReceived(event) {
            let message = null
            if (event.customType == 'eventMessages') {
                message = JSON.parse(event.message);
                dataLayer.push(message)
            }

            if (this.isUserAdmitted && event.customType != 'eventMessages') {
                message = event.message;
                if (event.publisher !== this.userId) {
                    if (!this.isChatComponentVisible) {
                        this.areLatestMessagesFetched = true
                    }
                    this.showMessage(event.publisher, event.message, event.timestamp);
                    this.scrollToBottom();
                }
            }

        },

        async loginRTM(channelName, appId) {

            const token = this.rtmToken
            try {
                rtm = new AgoraRTM.RTM(appId, this.userId);
            } catch (error) {
                console.log("Error initializing RTM:", error);
                dataLayer.push({
                    event: 'onLiveCallChatError',
                    'error': "Error initializing RTM:" + error,
                    'csrId': this.channelName
                });
                return;
            }

            rtm.addEventListener("message", this.messageHandler);

            try {
                await rtm.login({token});
                console.log("Logged in successfully");
            } catch (error) {
                dataLayer.push({
                    event: 'onLiveCallChatError',
                    'error': "Login error:" + error,
                    'csrId': this.channelName
                });
                console.log("Login error:", error);
                return;
            }

            try {
                await rtm.subscribe(channelName);
                console.log("Subscribed successfully");
                const user = window.username || (posthog?.__loaded ? posthog.get_distinct_id() : 'unknown');
                this.publishMessage({user, remoteUserId: this.currentUserID}, this.channelName, "userJoinMessage");

            } catch (error) {
                dataLayer.push({
                    event: 'onLiveCallChatError',
                    'error': "Subscription error:" + error,
                    'csrId': this.channelName
                });
                console.log("Subscription error:", error);
            }
        },

        async removeAllRtmEventlisteners() {
            this.chatMessages = [];
            this.isChatComponentVisible = false
            rtm.removeEventListener("message", this.messageHandler);
            await rtm.logout();
        },


        onUserJoined(agoraClient) {

            agoraClient.on('user-joined', async (user, mediaType) => {
                if (!this.remoteUsersTrackList[user.uid]) {
                    this.remoteUsersTrackList[user.uid] = {
                        audio: null,
                        video: null,
                        isVideoTrackSubscribed: false,
                        isAudioTrackSubscribed: false
                    };
                }
                console.log(`User ${user.uid} joined ${mediaType}`);

                this.remoteUserId = user.uid
                this.remoteUsersListMap.set(user.uid, {user, mediaType});

            });


            agoraClient.on('user-published', async (user, mediaType) => {
                console.log(`User ${user.uid} published ${mediaType}`);
                if (!this.remoteUsersTrackList[user.uid]) {
                    this.remoteUsersTrackList[user.uid] = {
                        audio: null,
                        video: null,
                        isVideoTrackSubscribed: false,
                        isAudioTrackSubscribed: false
                    };
                }

                if (mediaType == 'audio') {
                    this.remoteUsersTrackList[user.uid].audio = mediaType
                }

                if (mediaType == 'video') {
                    this.remoteUsersTrackList[user.uid].video = mediaType
                }

                if (this.hasRemoteUserJoined) {
                    this.admitUser(user, mediaType, agoraClient);
                    return
                }

                this.remoteUserId = user.uid
                this.remoteUsersListMap.set(user.uid, {user, mediaType});

            });

            agoraClient.on("user-unpublished", (user, mediaType) => {
                if (mediaType == 'audio') {
                    this.remoteUsersTrackList[user.uid].audio = null
                    this.remoteUsersTrackList[user.uid].isAudioTrackSubscribed = false
                }

                if (mediaType == 'video') {
                    this.remoteUsersTrackList[user.uid].video = null
                    this.remoteUsersTrackList[user.uid].isVideoTrackSubscribed = false
                }

                if (mediaType === "video") {
                    console.log(`Remote user ${user.uid} disabled their camera.`);
                    this.isRemoteUserCameraEnabled = false
                } else if (mediaType === "audio") {
                    console.log(`Remote user ${user.uid} disabled their audio.`);
                }
            });
        },
        formatDuration(milliseconds) {

            if (!milliseconds) {
                return
            }
            const totalSeconds = Math.floor(milliseconds / 1000);
            const hours = Math.floor(totalSeconds / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = totalSeconds % 60;

            let formattedDuration = "";
            if (hours > 0) {
                formattedDuration += `${hours} hour${hours !== 1 ? "s" : ""} `;
            }
            if (minutes > 0 || hours > 0) {
                formattedDuration += `${minutes} minute${minutes !== 1 ? "s" : ""} `;
            }
            formattedDuration += `${seconds} second${seconds !== 1 ? "s" : ""}`;

            return formattedDuration.trim();
        },

        isMoreThan32KB(message) {
            const encoder = new TextEncoder();
            const byteSize = encoder.encode(message).length;
            const maxBytes = 32 * 1024;

            if (byteSize > maxBytes) {
                return true;
            }
            return false;
        },

        async leaveChannel(state = '') {
            this.callRingtone.pause();
            this.callRingtone.currentTime = 0
            this.removeChannelStateListener();
            clearTimeout(this.videoCallJoinDelayTimeoutRef);
            await firebase.database().ref(this.channelName + "/queue/" + this.currentUserID).remove();
            if (this.isUserAdmitted) {
                this.isUserAdmitted = false
                this.removeAllRtmEventlisteners();
            }
            if (state == 'End Call') {
                dataLayer.push({event: 'onCustomerEndCallClicked', 'csrId': this.channelName});
            }

            if (state == 'Missed Call') {
                dataLayer.push({event: 'onCustomerMissedCall', 'csrId': this.channelName});
            }

            if (this.hasRemoteUserJoined) {
                const endDuration = new Date()
                const totalCallDuration = endDuration - new Date(this.startDuration)
                dataLayer.push({
                    event: 'onCustomerCallEnd',
                    'endDuration': endDuration.toLocaleString(),
                    'totalCallDuration': this.formatDuration(totalCallDuration),
                    'callEndType': state,
                    'csrId': this.channelName
                });
            } else {
                dataLayer.push({event: 'onCustomerCallEnd', 'callEndType': state, 'csrId': this.channelName});
            }

            this.isRemoteUserCameraEnabled = false
            this.hasRemoteUserJoined = false
            this.isCameraEnabled = false
            this.isAudioMuted = false
            this.areLatestMessagesFetched = false


            try {
                await agoraClient.leave();
                console.log('Left the channel');

                if (localAudioTrack) {
                    localAudioTrack.stop();
                    localAudioTrack.close();
                }
                if (localVideoTrack) {
                    localVideoTrack.stop();
                    localVideoTrack.close();
                }

                document.getElementById('local-stream').innerHTML = '';
                document.getElementById('remote-stream').innerHTML = '';

                if (remoteVideoTrack) {
                    remoteVideoTrack.stop();
                    remoteVideoTrack = null;
                }
                if (remoteAudioTrack) {
                    remoteAudioTrack.stop();
                    remoteAudioTrack = null;
                }
                this.isVideoJoined = false
                this.disableScroll = false

                console.log('Successfully cleaned up streams');
            } catch (error) {
                dataLayer.push({
                    event: 'onLiveCallError',
                    'error': 'Error leaving channel:' + error,
                    'csrId': this.channelName
                });
                console.error('Error leaving channel:', error);
            }
        },

        async toggleCameraTrack() {
            try {
                if (!this.isCameraEnabled) {
                    // Enable camera track
                    dataLayer.push({event: 'onCustomerCameraToggled', 'isEnabled': true, 'csrId': this.channelName});

                    const cameraTrack = await AgoraRTC.createCameraVideoTrack();

                    // Replace the current published track with the camera track
                    if (localVideoTrack) {
                        await agoraClient.unpublish(localVideoTrack); // Unpublish current track
                        localVideoTrack.close(); // Release the existing track
                    }

                    await agoraClient.publish(cameraTrack); // Publish the new camera track
                    localVideoTrack = cameraTrack; // Update reference to the local video track
                    localVideoTrack.play('local-stream');
                    this.isCameraEnabled = true;
                    console.log("Camera track enabled");
                } else {
                    // Disable camera track (only audio remains active)
                    dataLayer.push({event: 'onCustomerCameraToggled', 'isEnabled': false, 'csrId': this.channelName});

                    if (localVideoTrack) {
                        await agoraClient.unpublish(localVideoTrack); // Unpublish video track
                        localVideoTrack.close(); // Release the video track
                        localVideoTrack = null; // Clear the reference
                    }
                    this.isCameraEnabled = false;
                    console.log("Camera track disabled, only audio is active");
                }
            } catch (error) {
                dataLayer.push({
                    event: 'onLiveCallError',
                    'error': "Error toggling camera track:" + error,
                    'csrId': this.channelName
                });
                console.error("Error toggling camera track:", error);
                this.showError(CAMERA_PERMISSION_DENIED_MSG);
            }
        },

        onUserLeft(agoraClient) {
            // Handle remote user leaving
            agoraClient.on('user-left', (user) => {
                console.log(`User ${user.uid} left the channel`);
                if (remoteVideoTrack) {
                    remoteVideoTrack.stop();
                    this.hasRemoteUserJoined = false
                    document.getElementById('remote-stream').innerHTML = '';
                }
            });
        },

        async joinChannel(vsrId, channelName, appId) {
            this.channelName = channelName
            try {
                const token = await this.generateAgoraToken(channelName, "publisher", 3600);
                if (!token) {
                    console.error('Error generating token');
                    return
                }
                console.log(`Joining channel: ${this.channelName}`);
                const uid = await agoraClient.join(appId, channelName, token);
                if (dataLayer) {
                    dataLayer.push({event: 'onUserJoinedLiveCall', 'userId': uid});
                }
                this.currentUserID = uid
                console.log(`Joined channel as user: ${uid}`);

                localAudioTrack = await AgoraRTC.createMicrophoneAudioTrack();
                // Play local video track
                // Publish local tracks to the channel
                await agoraClient.publish(localAudioTrack);
                document.getElementById('callJoinPreview').style.display = 'none';
                this.callRingtone.play()
                this.listenForJoinedChannelStateUpdates(channelName, appId);
                this.isCsrInCall = true;
                this.isVideoJoined = true;
                this.disableScroll = true
                this.loginRTM(channelName, appId);
                this.callTimeoutRef = setTimeout(() => {
                    this.leaveChannel('Missed Call');
                }, 60000);

            } catch (error) {
                dataLayer.push({
                    event: 'onLiveCallError',
                    'error': 'Error joining channel:' + error,
                    'csrId': this.channelName
                });
                console.error('Error joining channel:', error);
                this.callRingtone.pause();
                this.callRingtone.currentTime = 0
            }
        },

        async generateAgoraToken(channelName, uid, role, expireTime) {
            try {
                const response = await fetch(`/api/v1/agora-token/`, {
                    headers: this.headers,
                    method: "POST",
                    body: JSON.stringify({
                        "channel_name": channelName,
                        "user_account": this.userId,
                    })
                });
                const responseData = await response.json();
                this.token = responseData?.data?.rtc_token;
                this.rtmToken = responseData?.data?.rtm_token;
            } catch (error) {
                console.error(error);
                dataLayer.push({
                    event: 'onLiveCallError',
                    'error': 'Error Generating RTC Token:' + error,
                    'csrId': this.channelName
                });

            } finally {
                return this.token || null;
            }
        },

        initFirebase() {
            firebaseRef = firebase.initializeApp(firebaseConfig);
            this.getAllChannels();
            this.listenForChannelStateUpdates()
        },

        handleMute() {
            if (this.isAudioMuted) {
                dataLayer.push({event: 'onCustomerMicrophoneToggled', 'isEnabled': true, 'csrId': this.channelName});
                localAudioTrack.setMuted(false);
                this.isAudioMuted = false
            } else {
                dataLayer.push({event: 'onCustomerMicrophoneToggled', 'isEnabled': false, 'csrId': this.channelName});
                localAudioTrack.setMuted(true);
                this.isAudioMuted = true
            }
        },

        async requestMediaPermissions() {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({audio: true});
                stream.getTracks().forEach((track) => track.stop());
                return true;
            } catch (error) {
                return false;
            }
        },

        initiateCallOnPageLoad() {
            const user = Object.keys(this.channelsList).find((channel) => this.channelsList[channel].status === this.callStatusEnum.AVAILABLE);
            if (!user) {
                this.showError(BUSY_ERR_MSG);
                return;
            }

            this.joinCall(user, this.channelsList[user]?.status, this.channelsList[user]?.channelName, this.channelsList[user]?.appId, this.channelsList[user]?.profile_image, 'Page Load');

        },


        onConnectCallClicked(vsrId, status, channelName, appId, profilePicture, gender = 'random', source) {
            dataLayer.push({event: 'onConnectCallClicked', 'csrId': vsrId, 'gender': gender, 'source': source});
            this.joinCall(vsrId, status, channelName, appId, profilePicture, gender, source);
        },

        async joinCall(vsrId, status, channelName, appId, profilePicture, gender = 'random', source) {
            clearTimeout(this.incomingCallTimeoutRef);

            const granted = await this.requestMediaPermissions();

            if (!granted) {
                this.showError(MICROPHONE_PERMISSION_DENIED_MSG);
                document.getElementById('callJoinPreview').style.display = 'none';
                dataLayer.push({event: 'onMediaPermissionsDenied', 'csrId': vsrId});
                return
            }
            this.csrProfilePicture = profilePicture
            if (status != this.callStatusEnum.AVAILABLE) {
                this.showError(BUSY_ERR_MSG);
                document.getElementById('callJoinPreview').style.display = 'none';
                return
            }
            this.joinChannel(vsrId, channelName, appId);
        },

        initiateCall(channelList) {
            if (this.csrAssistId) {
                const csrData = channelList[this.csrAssistId];
                if (csrData?.status != this.callStatusEnum.AVAILABLE) {
                    this.showError(BUSY_ERR_MSG);
                    document.getElementById('callJoinPreview').style.display = 'none';
                    return
                }
                this.joinCall(this.csrAssistId, csrData?.status, csrData?.channelName, csrData?.appId, csrData?.profile_image, csrData?.gender, 'Page Redirect');
            }

        },

        getAllChannels() {
            this.isVsrListLoaderActive = true
            const dbRef = firebase.database().ref();
            dbRef.get().then((snapshot) => {
                if (snapshot.exists()) {
                    this.channelsList = this.sortChannelsList(snapshot.val());
                    this.initiateCall(this.channelsList)
                }
            })
                .catch((error) => {
                    dataLayer.push({
                        event: 'onLiveCallError',
                        'error': 'Error Fetching All CSR List:' + error,
                        'csrId': this.channelName
                    });
                    this.showError(error);
                })
                .finally(() => {
                    this.isVsrListLoaderActive = false
                })
        },

        sortChannelsList(channelList) {
            const entries = Object.entries(channelList);
            entries.sort(([keyA, objA], [keyB, objB]) => {
                const statusOrder = {AVAILABLE: 1, BUSY: 2, OFFLINE: 3};
                return statusOrder[objA.status] - statusOrder[objB.status];
            });
            return Object.fromEntries(entries);
        },

        listenForChannelStateUpdates() {
            const dbRef = firebase.database().ref();
            dbRef.on('value', (snapshot) => {
                if (snapshot.exists()) {
                    this.channelsList = this.sortChannelsList(snapshot.val());
                }
            });
        },

        firebaseCallStateEventHandler(snapshot, channelName, appId) {
            const vsrCallUserId = this.channelsList[channelName]?.vsrCallUserId
            if (snapshot.exists()) {
                const data = snapshot.val()

                if (data) {
                    if (data?.status == "ADMITTED" && !this.hasRemoteUserJoined) {
                        const {user, mediaType} = this.remoteUsersListMap.get(vsrCallUserId);
                        this.callRingtone.pause();
                        this.callRingtone.currentTime = 0
                        this.executeAfterJoinDelay();
                        this.admitUser(user, mediaType);
                        if (!this.isUserAdmitted) {
                            this.isUserAdmitted = true
                            if (this.snowflake) {
                                this.publishMessage(window.domainURL + SIMPLIFIED_QUOTE_PAGE_URL + '?quote_id=' + this.snowflake, channelName);
                                this.snowflake = null
                            }
                        }
                        clearTimeout(this.callTimeoutRef);
                        this.startDuration = new Date().toLocaleString();
                        if (dataLayer) {
                            dataLayer.push({
                                event: 'onCustomerCallStart',
                                'startDuration': this.startDuration,
                                'csrId': this.channelName,
                                'userId': this.currentUserID,
                                'user': user.uid
                            });
                        }
                    }

                    if (data?.status == "BUSY") {
                        this.showError(BUSY_ERR_MSG);
                        clearTimeout(this.callTimeoutRef);
                        this.leaveChannel('Busy');
                    }

                    if (data?.status == "DENIED") {
                        this.showError(DECLINE_ERR_MSG);
                        clearTimeout(this.callTimeoutRef);
                        this.leaveChannel('Denied');
                    }

                    if (data?.status == "REJECTED") {
                        this.showError(REJECTED_ERR_MGS);
                        this.leaveChannel('Rejected');
                    }

                    if (data?.status == "ENDED") {
                        this.leaveChannel('OFFLINE');
                    }

                }
            }
        },

        listenForJoinedChannelStateUpdates(channelName, appId) {
            firebaseDBRef = firebaseRef.database().ref(channelName + "/queue/" + this.currentUserID);

            // Attach the event listener
            firebaseDBRef.on('value', (snapshot) => {
                this.channelStateUpdateListener(snapshot, channelName, appId);
            });
        },

        removeChannelStateListener() {
            firebaseDBRef.off('value', this.channelStateUpdateListener);
        }
    }))
})
